jQuery(".block__text-toggle .read-more").click(function(e) {
  e.preventDefault();
  $(".block__text-toggle__click").slideDown();
  $(this).hide(500);
});
